import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-list-view-export-error-modal',
  templateUrl: './list-view-export-error-modal.component.html',
})
export class ListViewExportErrorModalComponent {
  @Input() exportError;
  @Input() showErrorModal: boolean;
  @Output() modalClosed: EventEmitter<null> = new EventEmitter();
}
